"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unitType = void 0;
const enums_1 = require("@bemlo/enums");
exports.unitType = {
    [enums_1.UnitType.STRUCTURE]: 'Structure',
    [enums_1.UnitType.SITE]: 'Site',
    [enums_1.UnitType.TEAM]: 'Team',
};
